// LoginOTP.js
import React, { useContext, useEffect, useRef, useState } from 'react'
import WelcomeMessage from '../../components/WelcomeMessage/WelcomeMessage'
import OTPInput from '../../components/OTPInput/OTPInput'
import './LoginOTP.css'
import Button from '../../components/Button/Button'
import { useLocation, useNavigate } from 'react-router-dom'
import Services from '../../services/Services'
import { MallContext } from '../../MallContext'
import { useLanguage } from '../../LanguageProvider'

export default function LoginOTP() {
  const { getTranslation, language } = useLanguage();
  const { token, setToken } = useContext(MallContext)
  const navigate = useNavigate()
  const locationState = useLocation().state || {}
  const initialMethod = locationState.method || localStorage.getItem('loginMethod') || ''
  const initialPhone = locationState.phoneNumber || localStorage.getItem('loginPhone') || ''
  const initialEmail = locationState.email || localStorage.getItem('loginEmail') || ''

  const [method] = useState(initialMethod)
  const [phoneNumber] = useState(initialPhone)
  const [email] = useState(initialEmail)
  const [OTPCode, setOTPCode] = useState('')
  const [OTPMatch, setOTPMatch] = useState(true)
  const [isResendDisabled, setIsResendDisabled] = useState(false)
  const [countdown, setCountdown] = useState(0)
  const hasSentInitialOTP = useRef(false)

  const CODE_LENGTH = 6

  const sendOTP = async (withCooldown = false) => {
    if (!method) return
    if (method === 'phone' && !phoneNumber) return
    if (method === 'email' && !email) return
    const otpLang = language === "tr" ? "tr" : undefined

    if (withCooldown) {
      setIsResendDisabled(true)
      setCountdown(90)
    }

    if (method === 'phone') {
      try {
        const res = await Services.GetOTPViaPhone(phoneNumber, otpLang)
        console.log(res?.data?.result)
      } catch (err) {
        console.log(err)
      }
    } else if (method === 'email') {
      try {
        const res = await Services.GetOTPViaEmail(email, otpLang)
        console.log(res?.data?.result)
      } catch (err) {
        console.log(err)
      }
    }
  }

  useEffect(() => {
    let timer
    if (isResendDisabled && countdown > 0) {
      timer = setTimeout(() => {
        setCountdown((prev) => prev - 1)
      }, 1000)
    } else if (countdown === 0) {
      setIsResendDisabled(false)
    }

    return () => clearTimeout(timer)
  }, [countdown, isResendDisabled])

  useEffect(() => {
    if (hasSentInitialOTP.current) return
    if (!method) return
    if (method === 'phone' && !phoneNumber) return
    if (method === 'email' && !email) return

    sendOTP(false)
    hasSentInitialOTP.current = true
  }, [method, phoneNumber, email])

  useEffect(() => {
    // Kullanıcı login-otp sayfasına state olmadan gelirse login sayfasına yönlendir
    if (!method || (method === 'phone' && !phoneNumber) || (method === 'email' && !email)) {
      navigate('/login-phone')
    }
  }, [method, phoneNumber, email, navigate])

  const verifyAndContinue = async () => {
    let otpResultToken = ''
    try {
      let isOtpValid = false
      if (method === 'phone') {
        const res = await Services.CheckOTPViaPhone(phoneNumber, OTPCode)
        isOtpValid = res?.data?.status ?? !!res?.data?.result
        otpResultToken = res?.data?.result?.token || ''
      } else if (method === 'email') {
        const res = await Services.CheckOTPViaEmail(email, OTPCode)
        isOtpValid = res?.data?.status ?? !!res?.data?.result
        otpResultToken = res?.data?.result?.token || ''
      }

      if (!isOtpValid) {
        setOTPMatch(false)
        return
      }
      if (otpResultToken) {
        const tokenStr = typeof otpResultToken === 'string' ? otpResultToken : String(otpResultToken)
        localStorage.setItem('token', tokenStr)
        setToken(tokenStr)
      }
    } catch (err) {
      console.log(err)
      setOTPMatch(false)
      return
    }

    setOTPMatch(true)

    localStorage.setItem('loginMethod', method)

    if (method === 'phone') {
      const activeToken = otpResultToken || token
      if (!activeToken) return
      Services.GetCustomerByPhone(activeToken, phoneNumber)
        .then((res) => {
          if (res.data.status) {
            const { name, lastname, email, customer_id } = res.data.result

            localStorage.setItem('name', name)
            localStorage.setItem('lastname', lastname)
            localStorage.setItem('email', email)
            localStorage.setItem('customerID', customer_id)
            localStorage.setItem('phoneNumber', phoneNumber || '')
            navigate('/mainpage')
          } else {
            navigate('/register', { state: { phoneNumber } })
          }
        })
        .catch((err) => console.log(err))
    } else if (method === 'email') {
      const activeToken = otpResultToken || token
      if (!activeToken) return
      Services.GetCustomerByEmail(activeToken, email)
        .then((res) => {
          if (res.data.status) {
            const { name, lastname, email, customer_id } = res.data.result

            localStorage.setItem('name', name)
            localStorage.setItem('lastname', lastname)
            localStorage.setItem('email', email)
            localStorage.setItem('customerID', customer_id)
            localStorage.setItem('phoneNumber', phoneNumber || '')
            navigate('/mainpage')
          } else {
            navigate('/register', { state: { emailAddress: email } })
          }
        })
        .catch((err) => console.log(err))
    }
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <WelcomeMessage
        message={
          method === 'phone'
            ? getTranslation("enter6DigitCodePhone")
            : getTranslation("enter6DigitCodeEmail")
        }
      />

      <div style={{ marginTop: 15 }}>
        <OTPInput length={CODE_LENGTH} onChangeOTP={(arr) =>
          setOTPCode(arr.join(''))
        } />
      </div>

      {!OTPMatch && (
        <span className="resend-code" style={{ color: 'red' }}>
          {getTranslation("invalidCode")}
        </span>
      )}

      <span className="resend-code">
        {getTranslation("didNotReceiveCode")}{' '}
        <span
          onClick={!isResendDisabled ? () => sendOTP(true) : undefined}
          style={{
            marginLeft: 3,
            fontWeight: '500',
            textDecoration: isResendDisabled ? 'none' : 'underline',
            cursor: isResendDisabled ? 'not-allowed' : 'pointer',
          }}
        >
          {isResendDisabled
            ? `${getTranslation("resendCodeIn")} ${countdown}s`
            : getTranslation("resendCode")}
        </span>
      </span>

      <Button
        label={getTranslation("continue")}
        variant="primary"
        style={{ width: '100%', marginTop: 32, height: 44 }}
        disabled={OTPCode.length !== CODE_LENGTH}
        onClick={verifyAndContinue}
      />
    </div>
  )
}
